import Vue from 'vue';
export default Vue.extend({
    name: 'numberBox',
    props: {
        minified: {
            type: Boolean,
            required: false,
            default: false
        },
        prependIcon: {
            type: String,
            default: '',
            required: false
        },
        showClearIcon: {
            type: Boolean,
            required: false,
            default: false
        },
        textFieldLabel: {
            type: String,
            default: '',
            required: false
        },
        mask: {
            type: Object,
            required: false,
            default: () => ({
                alias: 'decimal',
                placeholder: ''
            })
        },
        allowDecimalInput: {
            type: String,
            required: false
        },
        value: {
            type: Number,
            required: true
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            required: true
        },
        rules: {
            type: Array,
            required: false,
            default: () => []
        },
        size: {
            type: String,
            default: 'small'
        },
        haveNegative: {
            type: Boolean,
            default: false
        },
        fillWidth: {
            type: Boolean,
            required: false,
            default: false
        },
        step: {
            type: Number,
            default: 1
        }
    },
    data: () => ({
        spinDialog: false,
        savedVal: 0,
        innerTextfieldKey: 0,
        isFocused: false
    }),
    computed: {
        letAddVal() {
            const vm = this;
            return vm.value < vm.max;
        },
        letSubtractVal() {
            const vm = this;
            return vm.value > vm.min;
        }
    },
    watch: {
        value(v) {
            const vm = this;
            if (v !== vm.savedVal) {
                vm.savedVal = v;
            }
        }
    },
    methods: {
        doSubtract(value, step) {
            var _a;
            const vm = this;
            const result = parseFloat((parseFloat(value - step + '')).toFixed(((_a = ((step + '').split('.')[1])) === null || _a === void 0 ? void 0 : _a.length) || 1));
            if (result < vm.min) {
                vm.$emit('input', vm.min);
            }
            else {
                vm.$emit('input', result);
            }
        },
        doAdd(value, step) {
            var _a;
            const vm = this;
            const result = parseFloat((parseFloat(value + step + '')).toFixed(((_a = ((step + '').split('.')[1])) === null || _a === void 0 ? void 0 : _a.length) || 1));
            if (result < vm.min) {
                vm.$emit('input', vm.min);
            }
            else {
                vm.$emit('input', result);
            }
        },
        handleKeydown(e) {
            const k = e.key;
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
            if ((e.key === '.' || e.key === ',') && !this.allowDecimalInput)
                e.preventDefault();
            const isKeyAllowed = allowedKeys.includes(k);
            if (isKeyAllowed) {
                if (!this.haveNegative) {
                    if (isNaN(Number(k)))
                        e.preventDefault();
                }
                else {
                    if (k !== '-' && isNaN(Number(k)))
                        e.preventDefault();
                }
            }
        },
        handleBlur() {
            const vm = this;
            if (isNaN(Number(vm.savedVal))) {
                vm.savedVal = vm.min;
            }
            else {
                if (vm.savedVal < vm.min)
                    vm.savedVal = vm.min;
            }
            vm.isFocused = false;
            let v = vm.savedVal;
            if (v > vm.max) {
                v = vm.max;
                vm.savedVal = vm.max;
            }
            if (v < vm.min) {
                v = vm.min;
                vm.savedVal = vm.min;
            }
            setTimeout(() => {
                vm.$emit('input', v);
                vm.innerTextfieldKey++;
            }, 0);
        },
        handleInput(v) {
            const vm = this;
            if (+v > vm.max) {
                vm.$emit('input', vm.max);
                vm.savedVal = vm.max;
            }
            else {
                vm.$emit('input', +v);
                vm.savedVal = +v;
            }
        }
    },
    mounted() {
        let controlButtonTypes;
        (function (controlButtonTypes) {
            controlButtonTypes["subtract"] = "subtract";
            controlButtonTypes["add"] = "add";
        })(controlButtonTypes || (controlButtonTypes = {}));
        const vm = this;
        const { subtractButton, addButton } = vm.$refs;
        function handleControlButtonMousedown(type) {
            let keyStillPressed = true;
            let timeoutID = null;
            function handleIteration() {
                if (keyStillPressed) {
                    if (type === controlButtonTypes.subtract) {
                        if (vm.letSubtractVal) {
                            vm.$emit('input', vm.value - vm.step);
                        }
                        else {
                            vm.$emit('input', vm.min);
                            keyStillPressed = false;
                            timeoutID = null;
                        }
                    }
                    else {
                        if (vm.letAddVal) {
                            vm.$emit('input', vm.value + vm.step);
                        }
                        else {
                            vm.$emit('input', vm.max);
                            keyStillPressed = false;
                            timeoutID = null;
                        }
                    }
                    timeoutID = setTimeout(handleIteration, 130);
                }
                else
                    timeoutID = null;
            }
            setTimeout(() => {
                if (keyStillPressed)
                    handleIteration();
            }, 300);
            function selfRemovableListenerOnMouseup() {
                timeoutID = null;
                subtractButton.removeEventListener('mouseup', selfRemovableListenerOnMouseup);
                addButton.removeEventListener('mouseup', selfRemovableListenerOnMouseup);
                keyStillPressed = false;
            }
            if (type === controlButtonTypes.subtract) {
                subtractButton.addEventListener('mouseup', selfRemovableListenerOnMouseup);
            }
            else
                addButton.addEventListener('mouseup', selfRemovableListenerOnMouseup);
        }
        subtractButton.addEventListener('mousedown', () => { handleControlButtonMousedown(controlButtonTypes.subtract); });
        addButton.addEventListener('mousedown', () => { handleControlButtonMousedown(controlButtonTypes.add); });
        vm.savedVal = +vm.value;
    }
});
